import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
// import Button from '@mui/material/Button';

export default function SimpleBackdrop() {
  return (
    <>
      <Backdrop
        open={true}
        style={{
          zIndex: 2000, // Directly set z-index
        }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
